import { render, staticRenderFns } from "./DrawingAccident.vue?vue&type=template&id=718d3f26&scoped=true&"
import script from "./DrawingAccident.vue?vue&type=script&lang=js&"
export * from "./DrawingAccident.vue?vue&type=script&lang=js&"
import style0 from "./DrawingAccident.vue?vue&type=style&index=0&id=718d3f26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d3f26",
  null
  
)

export default component.exports